import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/services/auth'
// auth
import MainLogin from '@/layouts/auth/MainLogin'
import Login from '@/components/auth/Login'
import NuevaContraseña from '@/components/auth/NuevaContraseña'
import RecuperarContraseña from '@/components/auth/RecuperarContraseña'
import Registro from '@/components/auth/Registro'
import Verificacion from '@/components/auth/Verificacion'

//user
import MainUser from '@/layouts/user/MainUser'
import InicioUsuario from '@/components/user/InicioUsuario'
import CompletarDatos from '@/components/user/CompletarDatos'
import Operacion from '@/components/user/Operacion'
import OperacionesVerificando from '@/components/user/OperacionesVerificando'
import DetalleOperaciones from '@/components/user/DetalleOperaciones'
import DetalleOperacionesVerificadas from '@/components/user/DetalleOperacionesVerificadas'
import Perfil from '@/components/user/Perfil'
import CuentasBancarias from '@/components/user/CuentasBancarias'
import EditarCuentasBancarias from '@/components/user/EditarCuentasBancarias'
import EditarRegistro from '@/components/user/EditarRegistro'
import Preguntas from '@/components/pages/PreguntasFrecuentes'
import Descargas from '@/components/pages/Descargas'

//pages
import Main from '@/layouts/Main'
import Inicio from '@/components/pages/Inicio'
import Information from '@/layouts/Information'
// no auth

Vue.use(Router)

let routes = [{
        path: '/',
        meta: {  },
        component: Main,
        redirect: '/',
        children: [
            { path: '/', name: 'Inicio', component: Inicio },
            //{ path: '/', redirect:{ name: 'Inicio' } },
            { path: '/inicio', name: 'Inicio', component: Inicio },
        ]
    },
    {
        path: '/preguntas',
        meta: {  },
        component: Preguntas,
        
    },
    {
        path: '/descargas',
        meta: {  },
        component: Descargas,
        
    },
    {
        path: '/',
        meta: { requiresGuest: true },
        component: MainLogin,
        redirect: '/login',
        children: [
            { path: 'auth-login', name: 'Login', component: Login },
            { path: 'auth-nueva-contrasena', name: 'NuevaContraseña', component: NuevaContraseña },
            { path: 'auth-recuperar-contrasena', name: 'RecuperarContraseña', component: RecuperarContraseña },
            { path: 'auth-registro', name: 'Registro', component: Registro },
            { path: 'auth-verificacion', name: 'Verificacion', component: Verificacion },
        ]
    },
    {
        path: '/',
        meta: { requiresAuth: true },
        component: MainUser,
        redirect: '/inicio-usuario',
        children: [
            { path: 'user-inicio-usuario', name: 'InicioUsuario', component: InicioUsuario },
            { path: 'user-completar-datos', name: 'CompletarDatos', component: CompletarDatos },
            { path: 'user-operacion', name: 'Operacion', component: Operacion },
            { path: 'user-operaciones-verificando', name: 'OperacionesVerificando', component: OperacionesVerificando },
            { path: 'user-detalle-operaciones', name: 'DetalleOperaciones', component: DetalleOperaciones },
            { path: 'user-detalle-operaciones-verificadas', name: 'DetalleOperacionesVerificadas', component: DetalleOperacionesVerificadas },
            { path: 'user-perfil', name: 'Perfil', component: Perfil },
            { path: 'user-cuentas-usuario', name: 'CuentasBancarias', component: CuentasBancarias },
            { path: 'user-editar-perfil-usuario', name: 'EditarRegistro', component: EditarRegistro},
            { path: 'user-editar-cuentas-bancarias', name: 'EditarCuentasBancarias', component: EditarCuentasBancarias}
        ]
    },
    
];

const router = new Router({
    mode: 'history', //comentar esto en caso de desarrollo
    base: '/',
    routes,
    //linkActiveClass: 'active',
});

router.beforeEach((to, from, next) => {

    if (to.matched.some(m => m.meta.requiresAuth)) {
        if (!auth.check()) {
            return next({ path: '/auth-login' })
        }
        return next()
    }

    if (to.matched.some(m => m.meta.requiresGuest)) {
        if (auth.check()) {
            return next({ path: '/user-inicio-usuario' })
        }

        return next()
    }

    return next()
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js